<template>
  <div class="screen" :class="seasonClass">
    <img class="logo1" :src="seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_logo1.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/spbcn-cebsb.png'" alt="">
    <img class="logo2" :src="seasonClass === 'season1' ? 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_logo2.png' : 'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/wzdlsj.png'" alt="">
    <img class="content" v-if="seasonClass === 'season1'" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_vision.png" alt="">
    <div class="btns">
      <div class="btn btn1" @click="tapFn(1)">
        <div class="cn">小组赛</div>
        <div class="en">Group Competition</div>
      </div>
      <div class="btn btn2" @click="tapFn(2)">
        <div class="cn">无组别 挑战赛2</div>
        <div class="en">Mixed Group Competition</div>
      </div>
    </div>
    <el-dialog :visible.sync="visible" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" width="580px">
      <div class="info-panel">
        <div class="info-title">请输入参赛编号</div>
        <div>
          <el-input class="info-inp" v-model="matchNum" type="number"></el-input>
        </div>
        <div class="info-btn" @click="confirm">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      group: '',
      matchNum: '',
      seasonClass: '',
      screenWidth: 0,
      screenHeight: 0,
      pageStyle: {
        width: '100%'
      },
      query: {},
      timer: null,
      season: '',
      matchTng: '' // 比赛状态 0-未开始 1-进行中 2-已结束
    }
  },
  created () {
    // this.visible = this.$route.query.enter !== '1'
    document.title = '汉英双拼大会'
    localStorage.removeItem('PAD_USER_INFO')
    this.season = this.$route.query.season
    this.seasonClass = this.season === '2022~2023' ? 'season1' : this.season === '2023~2024' ? 'season2' : 'season2'
  },
  methods: {
    tapFn (group) {
      if (group === 1) {
        this.$router.push(`/userLoginFinal3round2?activityType=1&season=${this.season}&group=${group}&raceSchedule=4&phase=2`)
      } else {
        this.$router.push(`/pad/login?group=${group}&season=${this.season}&raceSchedule=4`)
      }
    },
    confirm () {
      if (this.matchNum === '741852') {
        this.visible = false
      } else {
        this.$message.warning('参赛编号输入有误')
      }
    }
  },
  beforeDestroy () {

  }
}
</script>
<style scoped lang="less">
.screen{
  width: 100%;
  height: 100%;
  position: relative;
  color: #000;
  font-family: 'regular';
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding-top: 80px;
  box-sizing: border-box;
}
.logo1{
  position: absolute;
  left: 40px;
  top: 40px;
  width: auto;
  height: 40px;
}
.logo2{
  position: absolute;
  right: 60px;
  top: 40px;
  width: auto;
  height: 40px;
}
.content{
  width: 80%;
  margin: 10px auto 0;
  display: block;
}
.btns{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.btn{
  width: 350px;
  height: 70px;
  padding-top: 10px;
  box-sizing: border-box;
  // line-height: 64px;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  color: #000;
  .cn{
    font-size: 22px;
  }
  .en{
    font-size: 14px;
    font-family: fzcsk;
    margin-top: 2px;
  }
  &.btn1{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg2.png);
  }
  &.btn2{
    color: #fff;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
  }
}
.season1{
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rankbg.png);
}
.season2{
  // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/padbg.png);
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/2025/season3_welcome.jpg);
  background-size: 218% 100%;
  .btns{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40px;
  }
}
/deep/ .el-dialog{
  background: transparent;
  box-shadow: none;
  .info-panel{
    height: 300px;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.info-title{
  text-align: center;
  color: #000;
  font-size: 24px;
  padding-top: 80px;
}
.info-inp{
  width: 300px;
  margin: 20px auto;
  display: block;
  text-align: center;
}
.info-btn{
  background-color: #821d20;
  color: #fff;
  font-size: 18px;
  width: 180px;
  height: 42px;
  text-align: center;
  line-height: 38px;
  border-radius: 42px;
  margin: 30px auto
}
</style>
